module.exports = __webpack_public_path__ + "static/img/bg_empty.20bb460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_empty.png
// module id = rhmC
// module chunks = 167